export default "__VITE_ASSET__BAE9g2Y8__"